import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  TOKEN_INPUT: `${cleanedFilename(__filename)}-token-input`,
  SUBMIT: `${cleanedFilename(__filename)}-submit`,
  FORM: `${cleanedFilename(__filename)}-form`,
};
